import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {CheckOutlined, RightOutlined} from '@ant-design/icons';
import { Button} from 'antd'
import cn from 'classnames'

import {INDEX} from '../../config/routes';

import cls from './Registration.module.scss'

export const Done = () => {

    const {t} = useTranslation();
    const navigate = useNavigate()

    return (
       <div className={cls.done}>
           <div className={cn(['highlight', 'green'])}><CheckOutlined/> {t('Success')}</div>
           <div>
               <p>{t('You have registered successfully.')}</p>
               <p>{t('Now you have access to the full functionality of the platform.')}</p>
           </div>
           <Button type={'primary'} size={'large'} onClick={() => navigate(INDEX)} icon={<RightOutlined/>}>{t('To the main page')}</Button>
       </div>
    )
}